import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ReplyEmail } from './../../../../../Models/ReplyEmail';
import { EmailService } from './../../../../../Services/email.service';
import { TranslateService } from '@ngx-translate/core';
import { Helper } from 'src/app/helpers/helper.service';
import { ServiceRequestService } from './../../../../../Services/service-request.service';
import { Subscription, BehaviorSubject } from 'rxjs';
import { ServiceRequest } from './../../../../../../back-office/Models/ServiceRequest';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';
import * as Mustache from 'mustache';


@Component({
  selector: 'app-reply-step-email',
  templateUrl: './reply-step-email.component.html',
  styleUrls: ['./reply-step-email.component.scss'],
  animations: [
    trigger('fadeInOutTranslate', [
      transition(':enter', [
        style({opacity: 0}),
        animate('400ms ease-in-out', style({opacity: 1}))
      ]),
      transition(':leave', [
        style({transform: 'translate(0)'}),
        animate('400ms ease-in-out', style({opacity: 0}))
      ])
    ])
  ]
})
export class ReplyStepEmailComponent implements OnInit {

  @Input() Index;
  @Input() isActive;

  @ViewChild('previewModal', {static: false}) previewModal = null;

  public request: ServiceRequest = new ServiceRequest();
  private subscriptions: Subscription[] = [];
  public modules = {};
  public tokens = [];
  public rawTokens: any;
  public tabs = [];
  public iframeUrl: SafeResourceUrl;
  public emailBaseTemplate;
  public actionEmailTemplate;

  constructor(
    private requestService: ServiceRequestService,
    public helper: Helper,
    private translate: TranslateService,
    private emailService: EmailService,
    private sanitizer: DomSanitizer
  ) {
    this.modules = {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],

        [{'header': 1}, {'header': 2}],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        [{'direction': 'rtl'}],

        [{'size': ['small', false, 'large', 'huge']}],
        [{'header': [1, 2, 3, 4, 5, 6, false]}],

        [{'color': []}, {'background': []}],
        [{'align': []}],
        ['link']
      ]
    };

    this.tabs = [
      {title: 'body' , mapping: 'contentBody'},
      {title: 'title' , mapping: 'contentTitle'},
      {title: 'footer' , mapping: 'contentFooter'},
    ];

    this.tokens = [
      {description: 'current_user' , name: '{{current_user.fullname}}'},
      {description: 'order_number' , name: '{{order.orderNo}}'},
    ];
   }

   ngOnInit() {
    this.subscriptions.push(
      this.requestService.serviceRequest.subscribe(serviceRequest => {
        this.request = serviceRequest;
        this.request.reply.replyItems = this.request.reply.replyItems.filter(item => !item.solutionStep.restricted);
        const replyItem = this.request.reply.replyItems[this.Index];
        const actionEmail = replyItem?.solutionStep?.actionEmail;
        if (replyItem && actionEmail && !replyItem.replyEmail) {
          replyItem.replyEmail = new ReplyEmail();
          replyItem.replyEmail.contentTitle = actionEmail.contentTitle;
          replyItem.replyEmail.contentBody = actionEmail.contentBody;
          replyItem.replyEmail.contentFooter = actionEmail.contentFooter;
        }
      })
    );

    this.subscriptions.push(
      this.emailService.getTemplate().subscribe((res) => {
        this.emailBaseTemplate = res;
        this.subscriptions.push(
          this.emailService.getActionEmailBaseTemplate().subscribe((template) => {
            this.actionEmailTemplate = template;
            this.request.user.fullname = this.request.user.fullName;
            this.rawTokens = {current_user: this.request.user , order: this.request.order};
            this.updateEmailBody();
          })
        );
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  clipboardUpdated() {
    this.helper.showNotify('',
      this.translate.instant('admin.emails.manage.copied_to_clipboard'),
      'success'
    );
  }

  updateServiceRequest() {
    this.requestService.serviceRequest.next(this.request);
  }

  confirmStep() {
    const data = this.request.reply.replyItems[this.Index].replyEmail;
    this.subscriptions.push(
      this.requestService.confirmStep({serviceRequest: this.request.id , replyItem: this.request.reply.replyItems[this.Index].id , data: data}).subscribe(res => {
        this.requestService.fetchServiceRequestComplete(this.request.id , false);
      })
    );
  }

  updateEmailBody() {
    try {
      const preview = Mustache.render(this.actionEmailTemplate.content, this.rawTokens, {title: this.request.reply.replyItems[this.Index].replyEmail.contentTitle , body: this.request.reply.replyItems[this.Index].replyEmail.contentBody , footer: this.request.reply.replyItems[this.Index].replyEmail.contentFooter});
      const htmlPreview = Mustache.render(this.emailBaseTemplate.content, this.rawTokens, {contentBody: preview});
      this.updateIframe(htmlPreview);
    } catch (e) {
    }
  }

  updateIframe(html) {
    const encodedHtml = btoa(encodeURIComponent(html).replace(/%([0-9A-F]{2})/g,
      (match, p1) => String.fromCharCode(parseInt(p1, 16))));
    const dataUrl = `data:text/html;base64,${encodedHtml}`;
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl);
  }

  showPreview() {
    this.updateIframe(this.request.reply.replyItems[this.Index].replyEmail.emailLog.text);
    this.previewModal.show();
  }

}
